 document.addEventListener("DOMContentLoaded", function () {
    updateAddToCartButton();

    function updateAddToCartButton() {
      const isMobile = window.innerWidth <= 767;
      const containerSelector = isMobile
        ? ".custom__quantity_cart-mobile"
        : ".custom__cart__button";
      const targetContainer = document.querySelector(containerSelector);

      // Remove all existing .notify-me elements globally
      document.querySelectorAll(".notify-me").forEach(el => el.remove());

      const productForms = document.querySelectorAll("form[action*='/cart/add']");
      let notifyInserted = false;

      productForms.forEach(form => {
        // Skip hidden forms
        if (window.getComputedStyle(form).display === "none") return;

        const addToCartButton = form.querySelector(".product-form__submit, [id^='ProductSubmitButton']");

        if (addToCartButton && addToCartButton.disabled) {
          // Assume variant is unavailable if button is disabled
          addToCartButton.style.display = "none";

          if (!notifyInserted && targetContainer) {
            const notifyDiv = document.createElement("div");
            notifyDiv.className = "notify-me";
            targetContainer.appendChild(notifyDiv);
            notifyInserted = true;
          }

        } else if (addToCartButton) {
          addToCartButton.style.display = "";
          addToCartButton.disabled = false;

          const span = addToCartButton.querySelector("span");
          if (span) {
            span.textContent = "Add to cart";
          } else {
            addToCartButton.textContent = "Add to cart";
          }
        }
      });
    }
  });